const COLORS = {
  default: {
    referenceStroke: '#cccccc',
    stroke: '#107ef1',
  },
  violet: {
    referenceStroke: '#8547c5',
    stroke: '#8547c5',
  },
  teal: {
    referenceStroke: '#00c4c1',
    stroke: '#00c4c1',
  },
};

export default COLORS;
